import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { CommonButton } from '@/components/ui/common-button';

const CancelRequestDialog = ({ open, onOpenChange, submitting, onSubmit }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle className="text-lg font-bold text-foreground">Cancel Correction Request</DialogTitle>
        </DialogHeader>

        <div className="py-4 text-sm text-muted-foreground">
          Are you sure you want to cancel this correction request? This action cannot be undone.
        </div>

        <DialogFooter className="flex justify-end gap-2">
          <CommonButton 
            type="button" 
            variant="outline" 
            onClick={() => onOpenChange(false)} 
            disabled={submitting}
            className="w-32"
          >
            Cancel
          </CommonButton>
          <CommonButton 
            type="button" 
            variant="destructive" 
            onClick={onSubmit}
            loading={submitting}
            className="w-32"
          >
            Confirm Cancel
          </CommonButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CancelRequestDialog;
